import { render, staticRenderFns } from "./TransferList.vue?vue&type=template&id=216d59fe&scoped=true"
import script from "./TransferList.vue?vue&type=script&lang=js"
export * from "./TransferList.vue?vue&type=script&lang=js"
import style0 from "./TransferList.vue?vue&type=style&index=0&id=216d59fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d59fe",
  null
  
)

export default component.exports